import { selectedSectionsVar } from '../../gqlCommon/graphql/cache';

interface IExpandedSection {
  id: string;
  value: boolean;
}

const expandSectionService = {
  setExpandSection: (name: string) => {
    const expandedSection: IExpandedSection = {
      id: name,
      value: true,
    };
    const setSelectedSection = selectedSectionsVar().map(section => {
      const checkSectionValue = section.id === name && !section.value;
      return checkSectionValue ? expandedSection : section;
    });
    selectedSectionsVar(setSelectedSection);
  },
};

export default expandSectionService;
